<section>
  <h1>Example Ngrx form</h1>
  <!-- Error badge for displaying backend errors -->
  <!--  <error-badge *ngIf="error$ | async as error" [error]="error" />-->

  <sbi-cot-back-dynamic-form-implementation
    [structure$]="structure$"
    [data$]="data$"
    [buttonLabel]="'Publish Article'"
    [buttonSpinner$]="loading$"
    (updatedForm)="onUpdate($event)"
    (submitted)="onSubmit()"
  />
</section>
